/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { MdefyMarkdownEditorModule } from './shared/mdefy-markdown-editor/mdefy-markdown-editor.module';
// import { USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/auth';
import { USE_EMULATOR as USE_FIRESTORE_EMULATOR } from '@angular/fire/firestore';
import { USE_EMULATOR as USE_FUNCTION_EMULATOR } from '@angular/fire/functions';
import { environment } from '../environments/environment';

const {host, authPort, firestorePort, functionsPort} = environment.emulator || {};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    ThemeModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    // NbChatModule.forRoot({
    //   messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    // }),
    CoreModule.forRoot(),
    MdefyMarkdownEditorModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    // { provide: USE_AUTH_EMULATOR, useValue: environment.emulatorEnabled ? [host, authPort] : undefined},
    { provide: USE_FIRESTORE_EMULATOR, useValue: environment.emulatorEnabled ? [host, firestorePort] : undefined},
    { provide: USE_FUNCTION_EMULATOR, useValue: environment.emulatorEnabled ? [host, functionsPort] : undefined},
  ],
})
export class AppModule {
}
